/* eslint-disable class-methods-use-this */
import type { IUser } from './type'
import type { Auth0Client, Auth0ClientOptions } from '@auth0/auth0-spa-js'

import { createAuth0Client } from '@auth0/auth0-spa-js'

export class AuthService {
  private auth0: Auth0Client | null = null

  async init(options: Auth0ClientOptions): Promise<void> {
    this.auth0 = await createAuth0Client(options)
  }

  async isAuthenticated(): Promise<boolean> {
    if (!this.auth0) {
      throw new Error('Auth service must be initialised')
    }
    return this.auth0.isAuthenticated()
  }

  async getAccessToken(): Promise<string> {
    if (!this.auth0) {
      throw new Error('Auth service must be initialised')
    }
    return this.auth0.getTokenSilently()
  }

  async getUser(): Promise<IUser | undefined> {
    if (!this.auth0) {
      throw new Error('Auth service must be initialised')
    }

    return this.auth0.getUser()
  }
}

export const authService = new AuthService()
